import React from 'react'

export default function SolidityIcon() {
   return (
      <svg
         width="376"
         height="498"
         viewBox="0 0 376 498"
         className="w-100"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M122.415 476.582C112.959 476.582 108.543 472.07 108.543 465.926V465.638H111.999V466.262C111.999 470.87 114.879 473.366 122.415 473.366C128.847 473.366 131.775 471.59 131.775 467.942C131.775 464.342 129.615 463.046 124.911 462.086L118.095 460.79C112.863 459.782 108.687 457.574 108.687 452.246C108.687 447.878 112.431 443.462 121.647 443.462C130.719 443.462 134.751 448.262 134.751 454.118V454.406H131.295V453.83C131.295 449.174 128.415 446.678 121.407 446.678C115.023 446.678 112.143 448.502 112.143 452.006C112.143 455.654 114.255 456.758 119.007 457.766L125.775 459.11C131.535 460.214 135.231 462.662 135.231 467.654C135.231 472.262 131.343 476.582 122.415 476.582ZM151.269 476.582C143.541 476.582 138.405 471.446 138.405 464.246C138.405 457.046 143.541 451.91 151.269 451.91C159.045 451.91 164.181 457.046 164.181 464.246C164.181 471.446 159.045 476.582 151.269 476.582ZM151.269 473.51C157.797 473.51 160.821 470.006 160.821 464.246C160.821 458.534 157.797 454.982 151.269 454.982C144.741 454.982 141.765 458.534 141.765 464.246C141.765 470.006 144.741 473.51 151.269 473.51ZM172.124 476.102H168.716V443.942H172.124V476.102ZM181.265 449.366H177.857V443.942H181.265V449.366ZM181.265 476.102H177.857V452.39H181.265V476.102ZM197.221 476.582C189.637 476.582 185.413 471.446 185.413 464.246C185.413 457.046 189.637 451.91 196.933 451.91C202.549 451.91 206.053 454.934 207.109 459.014H207.349V443.942H210.757V476.102H207.637V469.094H207.445C206.293 473.846 202.453 476.582 197.221 476.582ZM188.869 464.246C188.869 471.11 192.517 473.462 198.085 473.462C203.653 473.462 207.349 470.246 207.349 464.63V464.198C207.349 458.342 203.845 455.078 197.989 455.078C192.565 455.078 188.869 457.382 188.869 464.246ZM219.89 449.366H216.482V443.942H219.89V449.366ZM219.89 476.102H216.482V452.39H219.89V476.102ZM240.166 476.102H235.03C230.326 476.102 227.302 474.134 227.302 468.566V455.318H223.078V452.39H227.302V446.726H230.758V452.39H240.166V455.318H230.758V468.758C230.758 472.07 232.39 472.982 235.846 472.982H240.166V476.102ZM247.023 484.262H244.047V481.142H247.647C250.047 481.142 250.959 480.422 251.871 478.454L253.023 476.054L241.263 452.39H245.007L251.967 466.502L254.607 472.31H254.895L257.439 466.454L264.015 452.39H267.759L254.895 479.414C253.167 483.062 250.959 484.262 247.023 484.262Z"
            fill="#F1ECDC"
         />
         <g clipPath="url(#clip0_5116_172555)">
            <path
               opacity="0.45"
               d="M238.939 27.0693L187.324 118.808H84.1602L135.736 27.0693H238.939Z"
               fill="#F1ECDC"
            />
            <path
               opacity="0.6"
               d="M187.324 118.808H290.515L238.943 27.0693H135.736L187.324 118.808Z"
               fill="#F1ECDC"
            />
            <path
               opacity="0.8"
               d="M135.736 210.507L187.324 118.808L135.736 27.0693L84.1602 118.808L135.736 210.507Z"
               fill="#F1ECDC"
            />
            <path
               opacity="0.45"
               d="M136.241 348.122L187.857 256.384H291.056L239.44 348.122H136.241Z"
               fill="#F1ECDC"
            />
            <path
               opacity="0.6"
               d="M187.857 256.384H84.666L136.242 348.122H239.441L187.857 256.384Z"
               fill="#F1ECDC"
            />
            <path
               opacity="0.8"
               d="M239.44 164.677L187.856 256.384L239.44 348.122L291.055 256.384L239.44 164.677Z"
               fill="#F1ECDC"
            />
         </g>
         <defs>
            <clippath id="clip0_5116_172555">
               <rect
                  width="206.896"
                  height="321.067"
                  fill="white"
                  transform="translate(84.1602 27.0625)"
               />
            </clippath>
         </defs>
      </svg>
   )
}
